import React from 'react';

// Stable per-user accent color derived from the id/name, so the fallback initials
// avatar keeps the same tint across renders and across viewers' screens.
const AVATAR_HUES = [
  'var(--accent-cyan)', 'var(--accent-green)', 'var(--accent-orange)',
  'var(--accent-red)', '#a78bfa', '#f472b6', '#38bdf8', '#facc15',
];

export function colorFor(key = '') {
  const s = String(key);
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return AVATAR_HUES[h % AVATAR_HUES.length];
}

export function initials(name) {
  const parts = String(name || '?').trim().split(/[\s_.-]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return String(name || '?').slice(0, 2).toUpperCase();
}

// Round avatar: shows the uploaded image when `src` is set, otherwise a colored
// initials badge. `ring` draws a highlight outline (used to mark the current user).
export default function Avatar({ src, name, userId, size = 24, ring, ringWidth = 2 }) {
  const ringStyle = ring ? { boxShadow: `0 0 0 ${ringWidth}px ${ring}` } : {};
  if (src) {
    return (
      <img
        src={src}
        alt={name || ''}
        style={{
          width: size, height: size, borderRadius: '50%',
          objectFit: 'cover', flexShrink: 0, background: 'var(--bg-elevated)',
          ...ringStyle,
        }}
      />
    );
  }
  return (
    <span style={{
      width: size, height: size, borderRadius: '50%',
      background: colorFor(userId || name), color: 'var(--bg-void)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'var(--font-display)', fontWeight: 800,
      fontSize: Math.max(8, Math.round(size * 0.42)), letterSpacing: 0,
      flexShrink: 0, ...ringStyle,
    }}>
      {initials(name)}
    </span>
  );
}
